import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Temporal } from '@js-temporal/polyfill';
import { TranslateService } from '@ngx-translate/core';
import { DateHelper } from '../shared/helpers';

@Pipe({
  name: 'datePlain'
})
export class PlainDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe,  private translate: TranslateService) {}

  transform(value: Temporal.PlainDate | null | undefined, format: string): string | null {
    if (!value) return null;
    const lang = this.translate.getCurrentLang() || 'hu';

    // Átalakítjuk a PlainDate értéket ISO stringgé, amit a DatePipe értelmezni tud
    const isoString = value.toString(); // 'YYYY-MM-DD' formátum
    
    if (!format)
        format = DateHelper.getLocalizedDateFormat(null, lang);

    // DatePipe használata a formázáshoz
    return this.datePipe.transform(isoString, format);
  }
}

@Pipe({
  name: 'localizedDate',
  pure: false // így újraértékelődik, ha változik a nyelv
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private translate: TranslateService
  ) {}

  transform(value: any, options: string): string | null {
    const lang = this.translate.getCurrentLang() || 'hu';
    let format = DateHelper.getLocalizedDateFormat(options, lang);
    return this.datePipe.transform(value, format, undefined, lang);
  }
}